import { render, staticRenderFns } from "./altcha.vue?vue&type=template&id=ea453318&scoped=true"
import script from "./altcha.vue?vue&type=script&lang=js"
export * from "./altcha.vue?vue&type=script&lang=js"
import style0 from "./altcha.vue?vue&type=style&index=0&id=ea453318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea453318",
  null
  
)

export default component.exports